import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="text-xs text-[#475569]">
    <ol className="flex items-center gap-1 flex-wrap">
      <li><Link to="/" className="flex items-center gap-1 hover:text-[#1088D4]"><Home size={12}/> Home</Link></li>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight size={12} className="text-[#94A3B8]"/>
          <li>
            {it.to && i < items.length-1 ? (
              <Link to={it.to} className="hover:text-[#1088D4]">{it.label}</Link>
            ) : <span className="text-[#273B59] font-medium">{it.label}</span>}
          </li>
        </React.Fragment>
      ))}
    </ol>
  </nav>
);
